"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRolAutoglideLinkUnsafe = exports.isRolAutoglideLink = exports.rolAutoglideLinkUseableDef = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const schemaVersions_1 = require("../schemaVersions");
const ArticleSpecs_1 = require("../ArticleSpecs");
exports.rolAutoglideLinkUseableDef = {
    parent: schemaVersions_1.linkLatestUseableDef,
    validation: {
        // todo LinkType instead of ArticleSpecs [EKE-11146]
        ArticleSpecs: (type) => Boolean(type === null || type === void 0 ? void 0 : type.includes(ArticleSpecs_1.ArticleSpecs.rolEchainAutoglideLink)),
        Teilung: echain_shared_quantities_1.isQuantityJson,
        Innenhoehe: echain_shared_quantities_1.isQuantityJson,
        Innenbreite: echain_shared_quantities_1.isQuantityJson,
        Aussenhoehe: echain_shared_quantities_1.isQuantityJson,
        Aussenbreite: echain_shared_quantities_1.isQuantityJson,
        Id: true,
        Bezeichnung: true,
    },
    unsafeValidation: {
        ArticleSpecs: (specs) => Boolean(specs === null || specs === void 0 ? void 0 : specs.includes(ArticleSpecs_1.ArticleSpecs.rolEchainAutoglideLink)),
    },
};
exports.isRolAutoglideLink = echain_shared_modelling_1.UseableUtil.createGuard(exports.rolAutoglideLinkUseableDef);
exports.isRolAutoglideLinkUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.rolAutoglideLinkUseableDef);
//# sourceMappingURL=RolAutoglideLink.js.map